export class CreateQuotePartMessage {
  customerVisible: boolean
  inventoryItemId: number
  note: string
  quantity: number

  constructor(customerVisible: boolean, inventoryItemId: number, note: string, quantity: number) {
    this.customerVisible = customerVisible
    this.inventoryItemId = inventoryItemId
    this.note = note
    this.quantity = quantity
  }
}
  